import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/nexite-logooo.png";
import "./Header.css";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollPct, setScrollPct] = useState(0);
  const { pathname, hash } = useLocation();
  const rafRef = useRef(0);
  const scrolledRef = useRef(false);
  const scrollPctRef = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      if (rafRef.current) return;

      rafRef.current = window.requestAnimationFrame(() => {
        rafRef.current = 0;

        const y = window.scrollY || 0;
        const nextScrolled = y > 10;
        if (nextScrolled !== scrolledRef.current) {
          scrolledRef.current = nextScrolled;
          setScrolled(nextScrolled);
        }

        const docH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        const winH = window.innerHeight || 1;
        const max = Math.max(1, docH - winH);
        const nextPct = Math.min(100, Math.max(0, (y / max) * 100));
        if (Math.abs(nextPct - scrollPctRef.current) >= 1) {
          scrollPctRef.current = nextPct;
          setScrollPct(nextPct);
        }
      });
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname, hash]);

  const toggleMenu = () => setMenuOpen((v) => !v);
  const closeMenu = () => setMenuOpen(false);
  const isHomeTop = pathname === "/" && !scrolled;

  const NAV = [
    { label: "Home", to: "/", key: "home" },
    { label: "About", to: "/about", key: "about" },
    { label: "Services", to: "/services", key: "services" },
    { label: "Resources", to: "/resources", key: "resources" },
    { label: "Newsletter", to: "/newsletter", key: "newsletter" },
    { label: "Contact", to: "/contact", key: "contact" },
  ];

  const isActive = (item) => {
    if (item.key === "home") return pathname === "/";
    if (item.key === "about") return pathname === "/about";
    if (item.key === "services") return pathname === "/services" || ["/security","/network","/it-infrastructure","/general-order-supply"].includes(pathname);
    if (item.key === "resources") return pathname === "/resources" || pathname.startsWith("/resources/");
    if (item.key === "contact") return pathname === "/contact";
    if (item.key === "newsletter") return pathname === "/newsletter";
    return false;
  };

  return (
    <>
      <header
        className={`site-header ${scrolled ? "scrolled" : ""} ${menuOpen ? "menu-open" : ""} ${isHomeTop ? "home-top" : ""}`}
        style={{ "--scroll": `${scrollPct}%` }}
      >
        <div className="progress" aria-hidden="true" />
        <div className="header-inner">
          <div className="brand">
            <Link to="/" className="brand-link" aria-label="Go to Home" onClick={closeMenu}>
              <div className="brand-mark">
                <img className="brand-logo" src={logo} alt="Nexite Logo" />
              </div>
              <span className="brand-name">NEXITE</span>
            </Link>
          </div>

          <nav className="navbar" aria-label="Primary">
            <ul className="nav-links">
              {NAV.map((item) => (
                <li key={item.key}>
                  <Link
                    to={item.to}
                    onClick={closeMenu}
                    className="nav-link"
                    data-active={isActive(item)}
                  >
                    <span className="nav-text">{item.label}</span>
                    <span className="underline" aria-hidden="true" />
                    <span className="glow" aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
            <div className="nav-actions">
              <Link to="/contact" className="btn-cta" onClick={closeMenu}>
                <span className="shine" aria-hidden="true" />
                Get Quote
              </Link>
            </div>
          </nav>

          <button
            className="menu-toggle"
            onClick={toggleMenu}
            aria-expanded={menuOpen}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        <div className="header-accent" aria-hidden="true" />
        <div className="header-glow" aria-hidden="true" />
      </header>

      <div className={`mobile-panel ${menuOpen ? "open" : ""}`}>
        <ul className="mobile-links">
          {NAV.map((item) => (
            <li key={`m-${item.key}`}>
              <Link to={item.to} onClick={closeMenu}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <Link to="/contact" className="btn-cta mobile-cta" onClick={closeMenu}>
          <span className="shine" aria-hidden="true" />
          Get Quote
        </Link>
      </div>

      <div className={`backdrop ${menuOpen ? "show" : ""}`} onClick={closeMenu} />
    </>
  );
}

export default Header;